// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"eb6a9730","716":"afb508e4"}[chunkId] + ".chunk.js";
};